import type { AddressDataSource } from '~/api/data-source/address';
import { addressDataSource } from '~/api/data-source/address';
import type {
  CreateShippingAddressRequest,
  DeleteShippingAddressRequest,
  MarketShippingAddress,
  UpdateDefaultShippingAddressRequest,
  UpdateShippingAddressRequest,
} from '~/api/model';
import {
  marketShippingAddressSchema,
  parseModel,
  parseModelArray,
} from '~/api/model';

export interface AddressRepository {
  // Query
  getShippingAddresses(): Promise<MarketShippingAddress[]>;
  getDefaultShippingAddress(): Promise<MarketShippingAddress>;

  // Mutation
  createShippingAddress(data: CreateShippingAddressRequest): Promise<void>;
  updateShippingAddress(data: UpdateShippingAddressRequest): Promise<void>;
  deleteShippingAddress(data: DeleteShippingAddressRequest): Promise<void>;
  changeDefaultShippingAddress(
    data: UpdateDefaultShippingAddressRequest,
  ): Promise<void>;
}

export class AddressRepositoryImpl implements AddressRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly dataSource: AddressDataSource = addressDataSource,
  ) {}

  async getShippingAddresses() {
    const response = await this.dataSource.getShippingAddresses();
    return parseModelArray(
      marketShippingAddressSchema,
      response,
      'MarketShippingAddress',
    );
  }

  async getDefaultShippingAddress() {
    const response = await this.dataSource.getDefaultShippingAddress();
    return parseModel(
      marketShippingAddressSchema,
      response,
      'MarketShippingAddress',
    );
  }

  async createShippingAddress(data: CreateShippingAddressRequest) {
    await this.dataSource.createShippingAddress(data);
  }

  async updateShippingAddress(data: UpdateShippingAddressRequest) {
    await this.dataSource.updateShippingAddress(data);
  }

  async deleteShippingAddress(data: DeleteShippingAddressRequest) {
    await this.dataSource.deleteShippingAddress(data);
  }

  async changeDefaultShippingAddress(
    data: UpdateDefaultShippingAddressRequest,
  ) {
    await this.dataSource.changeDefaultShippingAddress(data);
  }
}

export const addressRepository = new AddressRepositoryImpl();
